<template>
  <div
    v-if="isToggle"
    class="chip chip-toggle"
    :class="{
      'chip-colored': colored,
      'chip-delete': canDelete,
    }"
    @click="clickChip"
  >
    <slot />
    <Button
      v-if="canDelete"
      class="transparent-button transparent-button--no-border"
      type="button"
      outlined
    >
      <IconRemove />
    </Button>
  </div>
  <div
    v-else
    class="chip"
    :class="{
      'chip-colored': colored,
      'chip-delete': canDelete,
      'chip-static': isStatic,
    }"
  >
    <slot />
    <Button
      v-if="canDelete"
      @click="clickChip"
      class="transparent-button transparent-button--no-border"
      type="button"
      outlined
    >
      <IconRemove />
    </Button>
    <IconCheckSmall v-if="isStatic" class="icon-check" />
  </div>
</template>

<script lang="ts" setup>
import { Button } from 'primevue';

import IconRemove from '@/icons/IconChipRemove.svg?component';
import IconCheckSmall from '@/icons/IconCheckSmall.svg?component';

const props = withDefaults(
  defineProps<{
    id?: number | null;
    colored?: boolean;
    canDelete?: boolean;
    isToggle?: boolean;
    isStatic?: boolean;
  }>(),
  {
    colored: false,
    canDelete: false,
    isToggle: false,
    isStatic: false,
  },
);

const emit = defineEmits(['chipClicked']);

const clickChip = () => {
  emit('chipClicked', props.id);
};
</script>

<style lang="scss">
.chip {
  @include mixins.rounded-border($size: variables.$vantage-base-sizing-xxxs);
  @include sizing.padding('xxxs');
  @include typography.font-body($weight: normal, $size: sm);
  align-items: center;
  background: variables.$vantage-base-primitives-color-border-100;
  display: inline-flex;
  gap: variables.$vantage-base-sizing-xxxs;
  margin: 0 auto;
  text-align: center;
}

.chip-toggle {
  @include mixins.rounded-border();
  cursor: pointer;
  margin: 0;
}

.chip-colored {
  @include mixins.rounded-border($color: variables.$vantage-base-primitives-color-primary-200);
  background: variables.$vantage-base-primitives-color-background-300;
  color: variables.$vantage-base-primitives-color-primary-500;
  height: 32px;
}

.chip-static {
  @include mixins.rounded-border(
    $color: variables.$vantage-base-primitives-color-border-100,
    $size: variables.$vantage-base-sizing-sm
  );
  @include sizing.padding('xxxs', 'xs');
  background: variables.$vantage-base-primitives-color-background-100;

  .icon-check {
    color: variables.$vantage-base-primitives-color-primary-500;
    flex-shrink: 0;
  }
}

.chips-container {
  @include mixins.flex-center(
    $horiz: flex-start,
    $gap: variables.$vantage-base-sizing-xxs,
    $wrap: true
  );

  > .chip {
    margin: 0;
  }
}
</style>
